const TREND_DELTA_INTEGER_DIGITS_WITH_FRACTION = 4;

function getIntegerDigitCount(value: number): number {
    const absoluteIntegerPart = Math.floor(Math.abs(value));

    if (absoluteIntegerPart === 0) {
        return 0;
    }

    return absoluteIntegerPart.toString().length;
}

export function getTrendDeltaMaximumFractionDigits(delta: number): number {
    return getIntegerDigitCount(delta) > TREND_DELTA_INTEGER_DIGITS_WITH_FRACTION ? 0 : 1;
}

export function getTrendDelta(options: {current: number; previous: number}): number {
    const {current, previous} = options;

    if (current && !previous) {
        return 100;
    }

    if (previous && !current) {
        return -100;
    }

    if (!previous && !current) {
        return 0;
    }

    return ((current - previous) / previous) * 100;
}
